<template lang="pug">
v-container.tabs-management.pa-8(fluid)
    v-row
      v-col
        h2.primary--text {{ $t('Portal.tabsManagement') }}
    v-row
      v-col
        draggable(
          :value="localFields"
          @input="inputList"
        )
          div(
            v-for="(field, index) in localFields",
            :key="field.name",
          )
            v-checkbox(
              :label="`${$tCheck(`${entity.name}.${field.name}`, $camelToString(field.label || field.name))} // ${entity.name} ${field.name}`",
              :input-value="hasValue(field.name)",
              @change="input($event, field, index)",
            )
            v-divider(v-if="index != (fields.length - 1)")
</template>

<script>
import Draggable from "vuedraggable";

export default {
  components: {
    Draggable,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    entity: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    localFields: [],
  }),
  methods: {
    hasValue(fieldName) {
      if (this.value.find(f => f.name === fieldName)) return true;
      return false;
    },
    input($event, field, index) {
      let copyValue = [...this.value];
      if ($event) {
        copyValue.push({ ...field, uiSequence: index });
      } else {
        copyValue = copyValue.filter(f => f.name !== field.name);
      }
      this.$emit('input', copyValue);
    },
    inputList(list) {
      const listWithSequence = list.map((val, index) => ({ ...val, uiSequence: index }));
      const updatedValues = [...this.value].map(field => {
        const newIndex = listWithSequence.find(f => f.name === field.name);
        if (newIndex) return { ...field, uiSequence: newIndex.uiSequence };
        return {...field};
      });
      this.$emit('input', updatedValues);
      this.localFields = [...listWithSequence];
    },
    arrangeFields(fields, value) {
      if (!this.value || this.value.length == 0) return [...fields];

      const cValue = [...value];
      const cFields = [...fields];

      const filteredFields =  _.filter(cFields, (f) => {
        return !cValue.some((v) => {
          return v.name === f.name;
        })
      });

      const sortedValue = _.sortBy(cValue, ['uiSequence']);

      sortedValue.forEach(v => {
        filteredFields.splice(v.uiSequence, 0, v);
      })

      return filteredFields;
    },
  },
  created() {
    this.localFields = this.arrangeFields(this.fields, this.value);
  },
}
</script>
